export default {
  Title: 'Tham số báo cáo',
  Year: 'Năm',
  All: 'Tất cả',
  Summary: 'Tổng hợp',
  Option: 'Tùy chọn',
  Source: 'Nguồn',
  Chapter: 'Chương',
  BudgetSubKindItem: 'Khoản',
  TemplateReport: 'Mẫu báo cáo',
  OptionsGetData: 'Tùy chọn lấy số liệu',
  FreeTemplate: 'Mẫu tự chủ',
  NotGetDataXDCB: 'Không lấy số liệu XDCB',
  PrintMonthSettlementAdjustment: 'In tháng chỉnh lý quyết toán',
  AndVoucherSettlementAdjustment: 'Bao gồm chứng từ chỉnh lý quyết toán',
  EstimateUsed: 'Dự toán đã sử dụng',
  GetWithDrawAndPayment: 'Lấy số rút thực chi và số thanh toán tạm ứng',
  GetWithDrawAndAdvance: 'Lấy số rút thực chi và rút tạm ứng',
  GetByFormulaSelfSetup: 'Lấy theo công thức tự thiết lập',
  SetupFormula: 'Thiết lập công thức',
  DisplayOption: 'Tùy chọn hiển thị',
  NextPageDownTitle: 'Thiết lập hạ thấp trang',
  NextPageDown1_4: 'Các trang sau hạ thấp 1/4 trang',
  NextPageDown1_8: 'Các trang sau hạ thấp 1/8 trang',
  RowCountKBNN: 'Số dòng KBNN ghi',
  DisplayUnitInformation: 'Hiển thị thông tin đơn vị theo:',
  ChoosePeriod: 'Chọn kỳ báo cáo',
  SelectAll: '<<Tất cả>>',
  GetDataSpendRegular: 'Lấy số liệu chi thường xuyên',
  GetDataXDCB: 'Lấy số liệu XDCB',
  CalculateAdvanceByStatisticCode: 'Tính số dư tạm ứng theo mã thống kê',
  IsNotGetData0051: 'Không lấy số liệu 0051, 0052, 0099',
  ViewDetailCashDeposit: 'Chi tiết số dư tiền mặt, tiền gửi',
  UnitLabel: 'Đơn vị tính:',
  SettingParam: 'Thiết lập tham số chung',
  ReloadData: 'Lấy dữ liệu mới',
  ViewDetail: 'Xem chi tiết',
  EndDate: 'Tính đến ngày: ',
  Tutorial1: 'Biểu đồ sẽ cập nhật theo số liệu mới nhất sau mỗi 1 tiếng. ',
  Tutorial2: 'Nếu cần xem ngay dữ liệu mới vui lòng nhấn ',
  Tutorial3: 'tại đây',
  Tutorial4: ' hoặc xem hướng dẫn sau:',
  ParamTitle: 'Tham số chung',
};
